import { useRef } from 'react';
import Hero from './sections/Hero';
import About from './sections/About';
import Projects from './sections/Projects';
import Contact from './sections/Contact';
import Navbar from './components/Navbar';
import ThemeToggle from './components/ThemeToggle';

function App() {
  const ref = useRef();
  return (
    <>
      <main ref={ref} className="app-sections">
        <Navbar />
        <Hero />
        <About />
        <Projects />
        <Contact />
        <ThemeToggle />
      </main>
    </>
  );
}

export default App;
